<template>
  <el-form-item :label="$t('common_byinput')+':'" prop="createByName"
                :label-width="isTree?(lang!=='zh-CN'?'85':'68'):'auto'">
    <el-select
        :disabled="disabled"
        filterable
        multiple
        collapse-tags
        collapse-tags-tooltip
        allow-create
        v-model="internalValue"
        class="m-2"
        size="small"
        default-first-option
        clearable
        :max-collapse-tags="1"
        :placeholder="$t('common.please.select')"
        v-select-load-more="loadMore"
    >
      <el-option
          v-for="item in createCustomerList"
          :key="item.userId"
          :label="item.userName"
          :value="item.userId"
      />
    </el-select>
  </el-form-item>
</template>

<script setup>
import {computed, ref, onMounted} from "vue";
import {getCreateCustomerList} from "@/api";
import {useStore} from "vuex";
import {throttle} from "@/utils/mylodash";

// 接收 v-model 绑定的值
const props = defineProps({
  modelValue: String,
  isTree: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  }
});
const emit = defineEmits(['update:modelValue']);

// 使用 computed 实现双向绑定
const internalValue = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val)
});

const store = useStore();
const lang = computed(() => store.state.system.langLocal)
const pageNo = ref(1);
const pageSize = ref(10);
const totals = ref(0);
const isCurrent = ref(false)
const totalPage = ref(0)
const createCustomerList = ref([]);

// 获取团队 ID
const teamId = computed(() => store.state.email.teamID);

// 获取建档人列表
const getList = async () => {
  const payload = {
    pageNo: pageNo.value,
    pageSize: pageSize.value,
    teamId: teamId.value,
  };
  const res = await getCreateCustomerList(payload);
  if (res.code !== 200) return;
  pageNo.value = res.result.pageNo;
  totals.value = res.result.total;
  totalPage.value = res.result.pages
  if (!isCurrent.value) {
    createCustomerList.value = res.result.records || [];
  } else {
    createCustomerList.value = [...createCustomerList.value, ...res.result.records]
  }
};

onMounted(() => {
  getList();

  // 默认选中第一个
  // if (!props.modelValue && createCustomerList.value.length > 0) {
  //   emit('update:modelValue', createCustomerList.value[0].userId);
  // }
});

const loadMore = throttle(() => {
  console.log("more")
  if (totalPage.value === pageNo.value) {
    return
  } else {
    isCurrent.value = true
    pageNo.value++
    getList()
  }
}, 500)


</script>